<div class="slide-webinar">
  <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1 slide-webinar__wrapper">
    <div class="d-flex flex-column slide-webinar__data">
      <div class="d-flex flex-column justify-content-between align-items-sm-center flex-sm-row mb-5 slide-webinar__header">
        <span class="slide-webinar__header-title mb-3 mb-sm-0">
          {{ slideData?.webinar?.title }}
        </span>
        @if ( slideData?.webinar?.users?.length) {
          <div class="d-flex align-items-center justslide-webinar__instructors">
            <span class="slide-webinar__instructors-title mr-2">{{'WEBINARS.instructors' | translate}}: </span>
            <div class="slide-webinar__instructors-list">
              @for (user of slideData?.webinar?.users | slice:0:3; track user; let last = $last) {
                <lib-user-avatar
                  [user]="user"
                  [size]="40"
                  [matTooltip]="user | userName | async"
                  matTooltipPosition="above">
                </lib-user-avatar>
              }
              @if (slideData?.webinar?.users.length > 3) {
                <div class="slide-webinar__instructors-more primary-background">
                  +{{ slideData?.webinar?.users.length - 3 }}
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (slideData?.webinar; as webinar) {
        <div class="slide-webinar__media">
          @if (webinar.mediaVideo || webinar.playList || webinar.embedVideo) {
            @if (webinar.mediaVideo || webinar.playList) {
              <lib-video
                [src]="webinar.mediaVideo | videoPresign | async"
                [video]="webinar.mediaVideo"
                type="video/mp4"
                (started)="logUserActivity(activityTypes.USER_START_WATCHING_VIDEO)"
                (watched)="logUserActivity(activityTypes.USER_WATCHED_VIDEO)"
                [poster]="{ uri: webinar.mediaImage | preSignedUrl | async | imageCrop: webinar.mediaImage?.crop | async }">
              </lib-video>
            } @else {
              <lib-video [embedVideo]="webinar.embedVideo" [poster]="webinar.embedVideo?.imageUrl"></lib-video>
            }
          } @else {
            <div class="webinar-details__image">
              <img 
                [cropImage]="webinar.mediaImage | preSignedUrl | async" 
                [crop]="webinar?.mediaImage?.crop" 
                [additionalOptions]="{width: 850}"
                [alt]="webinar?.mediaImage?.description || 'Webinar image'">
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
